import React from 'react';
import { useI18n } from './i18n';
import { ABTM_MAX_TOTAL } from './abtmSheet';

function VinegarList({ sheets, onSelect }) {
  const { t, tc, formatDate, formatNumber } = useI18n();
  if (sheets.length === 0) {
    return <div className="empty-state">{t('vinegar.list.empty')}</div>;
  }

  return (
    <div className="sheets-list">
      <h2>{t('vinegar.list.title')}</h2>
      <div className="cards">
        {sheets.map((s) => (
          <div key={s.id} className="card" onClick={() => onSelect(s)}>
            <div className="card-header">
              <h3>{s.product_name}</h3>
              {s.harvest_year && <span className="vintage">{s.harvest_year}</span>}
            </div>
            <div className="card-body">
              {s.producer && <p>{s.producer}</p>}
              {s.vinegar_kind && <p className="area">{tc('vinegar.kind', s.vinegar_kind)}{s.origin ? ` · ${s.origin}` : ''}</p>}
              {s.protocol && <p className="area">{tc('vinegar.protocol', s.protocol)}</p>}
              {s.protocol === 'abtm_dop' ? (
                s.abtm_total !== null && s.abtm_total !== undefined && (
                  <div className="card-score-final">{formatNumber(s.abtm_total, 0)}/{ABTM_MAX_TOTAL}</div>
                )
              ) : (s.overall !== null && s.overall !== undefined && (
                <div className="card-score-final">{formatNumber(s.overall, 1)}/10</div>
              ))}
            </div>
            <div className="card-footer">
              {formatDate(s.tasting_date) || '—'} {s.taster ? `· ${s.taster}` : ''}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default VinegarList;
